module.exports = __webpack_public_path__ + "img/img_Gross_Annual_Income.029ff75e.png";